import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getStatusTableColumn,
  // getProjectTableColumn,
} from '@/utils/common/tableColumn.js'

export default {
  computed: {
    isBackend () {
      return this.$route.path.includes('/backend-tech-support')
    },
  },
  created () {
    const columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      {
        field: 'type',
        title: this.$t('common_56'),
        formatter: ({ cellValue }) => {
          return cellValue === 'consulting' ? this.$t('scope.technical_consulting') : this.$t('scope.remote_assistance')
        },
      },
      getStatusTableColumn({
        field: 'status',
        title: this.$t('common.status'),
        statusModule: 'saasTechSupport',
        minWidth: 200,
        slotCallback: row => {
          const dismissTip = this.getWecomGroupDismissTip(row)
          return [
            <div class="d-flex flex-column">
              <status status={row.status} statusModule="saasTechSupport" />
              {row.status === 'completed' && dismissTip ? (
                <div
                  class="text-truncate"
                  title={dismissTip}
                  style="color: #f5222d; font-size: 12px; line-height: 1.4; margin-top: 4px;">
                  {dismissTip}
                </div>
              ) : null}
            </div>,
          ]
        },
      }),
      getTimeTableColumn({ sortable: true }),
      getTimeTableColumn({
        field: 'close_time',
        title: this.$t('scope.close_time'),
      }),
    ]
    if (this.isBackend) {
      columns.push({
        field: 'score',
        title: '评分',
      })
      columns.push({
        field: 'feedback',
        title: '意见建议',
      })
    }

    this.columns = columns
  },
  methods: {
    getWecomGroupDismissTip (row) {
      if (!row.close_time) return ''
      const dismissAt = this.$moment(row.close_time).add(7, 'days')
      if (!this.$moment().isBefore(dismissAt)) return ''
      return this.$t('scope.tech_support_wecom_group_dismiss_tip', [dismissAt.format('YYYY-MM-DD HH:mm')])
    },
  },
}
